//Style
import '../../styles/cv/card.scss'

//Basic
import React from 'react'

//Components
import Project from '../main/project'

//Images
import Reward from '../../assets/trophee.svg'
import LocationIcon from '../../assets/cv_location_icon.svg'
import CalendarIcon from '../../assets/cv_calendar_icon.svg'
import ToolsIcon from '../../assets/cv_tools_icon.svg'
import NotesIcon from '../../assets/cv_notes_icon.svg'
import SearchIcon from '../../assets/cv_search_icon.svg'

// Language
import { useLanguage } from '../../context/language_context'
import { translate } from '../../utils/translate'


function Card({
    selectedExperience,
    onExperienceClick,
    experiences,
    selectedButton,
    handleWorkButtonClick,
    handleEducationButtonClick,
    handleSkillsButtonClick
}) {

    const { language } = useLanguage()

    const {
        name,
        job_calendar,
        job_description,
        reward,
        job_place,
        strong_skills,
        good_skills,
        average_skills,
        weak_skills,
        tools = [],
        search
    } = selectedExperience || {}


    const selectedType = selectedExperience
        ? selectedExperience.type
        : ''


    const selectedExperiences = experiences.filter(
        (experience) =>
            experience.type === selectedType
    )


    const experienceCount = selectedExperiences.length

    const hasTools = tools.length > 0

    const translatedReward = translate(reward, language)

    const hasReward =
        translatedReward?.trim().length > 0


    return (

        <section className="cv_card">


            {/* TITLE */}

            <h3>

                {selectedType === 'work'
                    ? (
                        language === 'fr'
                            ? 'Expériences professionnelles'
                            : 'Work experience'
                    )
                    : (
                        language === 'fr'
                            ? 'Formation'
                            : 'Education'
                    )}

            </h3>


            {/* WINDOWS MENU */}

            <nav>

                <ul>
                    <li>File</li>
                    <li>Edit</li>
                    <li>View</li>
                    <li>Help</li>
                </ul>

            </nav>


            {/* CATEGORY BUTTONS */}

            <ul className='cv_buttons'>

                <li
                    className={`cv_button work_button ${selectedButton === 'work' ? 'selected' : ''}`}
                    onClick={handleWorkButtonClick}
                >
                    {language === 'fr'
                        ? 'expériences pro'
                        : 'work experience'}
                </li>


                <li
                    className={`cv_button education_button ${selectedButton === 'education' ? 'selected' : ''}`}
                    onClick={handleEducationButtonClick}
                >
                    {language === 'fr'
                        ? 'formation'
                        : 'education'}
                </li>


                <li
                    className={`cv_button stats_button ${selectedButton === 'stats' ? 'selected' : ''}`}
                    onClick={handleSkillsButtonClick}
                >
                    {language === 'fr'
                        ? 'compétences'
                        : 'skills'}
                </li>

            </ul>


            {/* MAIN */}

            <div className="cv_card_main">


                {/* EXPERIENCES */}

                <div className="cv_card_files">

                    {experiences.map((experience) => (

                        <Project
                            key={experience.id}
                            name={translate(experience.name, language)}
                            onOpen={() =>
                                onExperienceClick(experience)
                            }
                            isSelected={
                                experience === selectedExperience
                            }
                        />

                    ))}

                </div>


                {/* DETAILS */}

                <div className='cv_card_details'>


                    {/* EXPERIENCE TITLE */}

                    <div className='cv_card_title'>

                        <h3>
                            {translate(name, language)}
                        </h3>

                        <ul>


                            {/* LOCATION */}

                            <li>

                                <img
                                    src={LocationIcon}
                                    alt=""
                                />

                                {translate(job_place, language)}

                            </li>


                            {/* DATE */}

                            <li>

                                <img
                                    src={CalendarIcon}
                                    alt=""
                                />

                                {translate(job_calendar, language)}

                            </li>


                            {/* DESCRIPTION */}

                            <li>

                                <img
                                    src={NotesIcon}
                                    alt=""
                                />

                                {translate(job_description, language)}

                            </li>


                            {/* REWARD */}

                            {hasReward && (

                                <li>

                                    <img
                                        src={Reward}
                                        alt=""
                                    />

                                    {translatedReward}

                                </li>

                            )}

                        </ul>

                    </div>


                    {/* SKILLS */}

                    <div className='cv_card_skills'>

                        <h3>

                            {language === 'fr'
                                ? 'Compétences'
                                : 'Skills'}

                        </h3>


                        <ul>


                            <li>

                                <progress
                                    id="strong_skills"
                                    max="100"
                                    value="100"
                                />

                                <label htmlFor="strong_skills">
                                    {translate(strong_skills, language)}
                                </label>

                            </li>


                            <li>

                                <progress
                                    id="good_skills"
                                    max="100"
                                    value="90"
                                />

                                <label htmlFor="good_skills">
                                    {translate(good_skills, language)}
                                </label>

                            </li>


                            <li>

                                <progress
                                    id="average_skills"
                                    max="100"
                                    value="80"
                                />

                                <label htmlFor="average_skills">
                                    {translate(average_skills, language)}
                                </label>

                            </li>


                            <li>

                                <progress
                                    id="weak_skills"
                                    max="100"
                                    value="70"
                                />

                                <label htmlFor="weak_skills">
                                    {translate(weak_skills, language)}
                                </label>

                            </li>

                        </ul>

                    </div>


                    {/* TOOLS */}

                    {hasTools && (

                        <div className='cv_card_tools'>

                            <h3>

                                {language === 'fr'
                                    ? 'Outils et logiciels'
                                    : 'Tools and software'}

                            </h3>


                            <ul>

                                {tools.map((tool, index) => (

                                    <li
                                        className='cv_card_tool'
                                        key={index}
                                    >

                                        <img
                                            src={ToolsIcon}
                                            alt=""
                                        />

                                        <p>
                                            {translate(tool, language)}
                                        </p>

                                    </li>

                                ))}

                            </ul>

                        </div>

                    )}


                    {/* SEARCH */}

                    <div className='cv_card_search'>

                        <img
                            src={SearchIcon}
                            alt=""
                        />

                        {translate(search, language)}

                    </div>


                </div>

            </div>


            {/* FOOTER */}

            <p className='cv_card_footer'>

                {experienceCount}{' '}

                {selectedType === 'work'
                    ? (
                        language === 'fr'
                            ? (
                                experienceCount === 1
                                    ? 'expérience'
                                    : 'expériences'
                            )
                            : (
                                experienceCount === 1
                                    ? 'experience'
                                    : 'experiences'
                            )
                    )
                    : (
                        language === 'fr'
                            ? (
                                experienceCount === 1
                                    ? 'formation'
                                    : 'formations'
                            )
                            : 'education'
                    )}

            </p>

        </section>

    )
}


export default Card